var _path, _path2, _use, _use2, _use3, _use4, _use5, _use6, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icon-css-my",
    width: 640,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cc0001",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#fff",
    d: "M0 445.8h640V480H0z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -68.6)",
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -137.2)",
    xlinkHref: "#a"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -205.8)",
    xlinkHref: "#a"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -274.3)",
    xlinkHref: "#a"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -343)",
    xlinkHref: "#a"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "translate(0 -411.5)",
    xlinkHref: "#a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#010066",
    d: "M0 0h372.6v274.3H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.7 48.5c-49 0-88.9 39.7-88.9 88.6a88.8 88.8 0 0 0 89 88.6 88.7 88.7 0 0 0 48-14 78.9 78.9 0 0 1-25.8 4.2c-43.5 0-78.8-35.2-78.8-78.5a78.7 78.7 0 0 1 106.2-73.7 88.7 88.7 0 0 0-49.7-15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1 183.2l-37.4-19.5 11 40-25-33.5-7.8 40.7-7.7-40.7-25.1 33.4 11.2-40-37.6 19.5 28-31.3-42.5 1.6 39-16.3-39-16.5 42.5 1.7L178.9 91l37.4 19.5-11-40 25 33.5 7.8-40.7 7.7 40.7 25.1-33.3-11.2 39.9 37.6-19.4-28 31.2 42.5-1.6-39 16.4 39 16.5-42.5-1.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMys);
export default __webpack_public_path__ + "static/media/mys.645d2fbfdea51a5b71e3fbc29215085a.svg";
export { ForwardRef as ReactComponent };